import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 17h6l-4 -5l4 -5h-6l-4 5l4 5","key":"svg-0"}]]

/**
 * IconArrowBadgeLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmFkZ2UtbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTEgMTdoNmwtNCAtNWw0IC01aC02bC00IDVsNCA1IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-badge-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBadgeLeft = createReactComponent('outline', 'arrow-badge-left', 'ArrowBadgeLeft', __iconNode);

export default IconArrowBadgeLeft;